import styles from "./styles.module.css";
import cx from "classnames";
import Eye from "src/assets/icons/eye.svg";
import React, { useState } from "react";

type Props = {
  label?: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void; 
  disabled?: boolean;
  placeholder?: string;
  error?: string | undefined | false;
  type?: string;
  leftIcon?: string;
  className?: string;
  name?: string;
  autoFocus?: boolean;
};

export const Input: React.FC<Props> = ({
  label,
  value,
  onChange,
  onBlur,
  disabled,
  placeholder,
  error,
  type,
  leftIcon,
  className,
  name,
  autoFocus,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const inputType = type === "password" && isPasswordVisible ? "text" : type ?? "text";

  return (
    <div className={cx(styles.inputWrapper, className)}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.inputContainer}>
        {type === "password" && (
          <img 
            src={Eye} 
            alt="eye" 
            className={styles.passIcon}
            onClick={togglePasswordVisibility}
            style={{ 
              cursor: "pointer",
              opacity: isPasswordVisible ? 1 : 0.6 
            }}
          />
        )}
        {leftIcon && (
          <img src={leftIcon} alt="leftIcon" className={styles.leftIcon} />
        )}
        <input
          type={inputType}
          name={name}
          className={cx(styles.input, className, {
            [styles.disabledInput]: disabled,
            [styles.errorInput]: error,
          })}
          value={value}
          onChange={onChange}
          onBlur={onBlur} 
          placeholder={placeholder ?? ""}
          disabled={disabled}
          autoFocus={autoFocus}
        />
        {error && <p className={styles.errorText}>{error}</p>}
      </div>
    </div>
  );
};